export default __webpack_public_path__ + "static/media/logo.abf30155.jpg";